module.exports = __webpack_public_path__ + "img/GR071.32f35ea6.png";